import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createSolutionApi } from "../../services/solution/create.solution.api";

export const useCreateSolutionApi = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (createInfo: any) => createSolutionApi(createInfo),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["solution"],
      });
    },
  });
};
